import React from 'react';
import Button from 'commonComponents/Button/Button';
import BaseSection from 'commonComponents/sections/BaseSection/BaseSection';
import { TextBlock } from 'commonComponents/common';
import styles from './BaseSectionWithImage.module.scss';

const BaseSectionWithImage = ({
  headers,
  title,
  anchor,
  text,
  image,
  button,
  children
}) => {
  const additionalContent = <div>{ children }</div>;

  return (
    <BaseSection
      { ...headers }
      anchor={ anchor }
    >
      <div className={ styles.BaseSectionWithImage }>
        <article>
          { title && <h5 className={ styles.title }>{ title }</h5> }
          <TextBlock text={ text } />
          { button && <Button { ...button } /> }
        </article>
        <figure className={ styles.image }>
          <img src={ image } />
        </figure>
      </div>
      { children && additionalContent }
    </BaseSection>
  );
};
 
export default BaseSectionWithImage;
